module.exports = __webpack_public_path__ + "img/google_play.c2699c88.svg";